


















































































































import {
  SfOverlay, SfHeader, SfButton, SfBadge,
} from '@storefront-ui/vue';

import {
  computed,
  ref,
  defineComponent,
  useRouter,
  useContext,
  onMounted,
  useFetch,
} from '@nuxtjs/composition-api';
import HeaderNavigation from '~/components/Header/Navigation/HeaderNavigation.vue';
import { createCustomMenu, useCategory } from '~/modules/catalog/category/composables/useCategory';
import {
  useUiHelpers,
  useUiState,
} from '~/composables';
import { useCart } from '~/modules/checkout/composables/useCart';
import { useWishlist } from '~/modules/wishlist/composables/useWishlist';
import { useUser } from '~/modules/customer/composables/useUser';
import { useWishlistStore } from '~/modules/wishlist/store/wishlistStore';
import type { CategoryTree, ProductInterface } from '~/modules/GraphQL/types';
import HeaderLogo from '~/components/HeaderLogo.vue';
import SvgImage from '~/components/General/SvgImage.vue';
import { useTopBar } from './TopBar/useTopBar';
import { isEmpty } from "lodash-es";
import menu from "~/assets/menu.json";
export default defineComponent({
  components: {
    HeaderNavigation,
    SfHeader,
    SfOverlay,
    HeaderLogo,
    SvgImage,
    SfButton,
    SfBadge,
    CurrencySelector: () => import('~/components/CurrencySelector.vue'),
    StoreSwitcher: () => import('~/components/StoreSwitcher.vue'),
    SearchBar: () => import('~/components/Header/SearchBar/SearchBar.vue'),
    SearchResults: () => import(
      /* webpackPrefetch: true */ '~/components/Header/SearchBar/SearchResults.vue'
    ),
    SearchBarHeader: () =>
      import("~/components/Header/SearchBar/SearchBarHeader.vue"),
    CategoryProductGridSearch: () => import(
      "~/modules/catalog/category/components/views/CategoryProductGridSearch.vue"
    ),
  },
  setup() {
    const router = useRouter();
    const { app } = useContext();
    const { toggleCartSidebar, toggleWishlistSidebar, toggleLoginModal, toggleRegisterSuccessModal } = useUiState();
    const { setTermForUrl, getCatLink, getFacetsFromURL } = useUiHelpers();
    const { isAuthenticated } = useUser();
    const { loadTotalQty: loadCartTotalQty, cart } = useCart();
    const { loadItemsCount: loadWishlistItemsCount } = useWishlist();
    const { categories: categoryList, load: categoriesListLoad } = useCategory();

    const { hasCurrencyToSelect, hasStoresToSelect } = useTopBar();

    const isSearchOpen = ref(false);
    const productSearchResults = ref<ProductInterface[] | null>(null);
    const searchTerm = ref("");
    const wishlistStore = useWishlistStore();
    const wishlistItemsQty = computed(() => wishlistStore.wishlist?.items_count ?? 0);

    const wishlistHasProducts = computed(() => wishlistItemsQty.value > 0);
    const accountIcon = computed(() => (isAuthenticated.value ? 'profile_fill' : 'profile'));
    const categoryTree = ref<CategoryTree[]>([]);
    let categoryTreeMenu = ref<CategoryTree[]>([]);
    categoryTreeMenu = createCustomMenu()(menu);
    const handleAccountClick = async () => {
      if (isAuthenticated.value) {
        await router.push("/customer/my-profile");
      } else {
        toggleLoginModal();
      }
    };
    // useFetch(async () => {
    //   await categoriesListLoad({ pageSize: 20 });

    //   categoryTree.value = categoryList.value?.[0]?.children
    //     .filter((category) => category.include_in_menu);
    // });

    onMounted(async () => {
      searchTerm.value = getFacetsFromURL().term;
      if (app.$device.isDesktop) {
        await loadCartTotalQty();
        // eslint-disable-next-line promise/catch-or-return
        await loadWishlistItemsCount();
      }
    });
    const redirectUrlPath = () => {
      if (!isEmpty(searchTerm.value))
        router.push("/catalogsearch/result/?term=" + searchTerm.value);
    };
    return {
      accountIcon,
      cartTotalItems: computed(() => cart.value?.total_quantity ?? 0),
      categoryTree,
      getCatLink,
      handleAccountClick,
      isAuthenticated,
      isSearchOpen,
      productSearchResults,
      setTermForUrl,
      toggleCartSidebar,
      toggleWishlistSidebar,
      wishlistHasProducts,
      wishlistItemsQty,
      hasCurrencyToSelect,
      hasStoresToSelect,
      searchTerm,
      redirectUrlPath,
      categoryTreeMenu,
      getFacetsFromURL,
    };
  },
  watch:{
    $route (){
      this.searchTerm = this.getFacetsFromURL().term;
    }
  },
});
